import React, { ReactNode } from 'react';

import ClickableIcon from '~components/ClickableIcon';
import { faInfoCircle } from '~components/icon';

interface ComponentProps {
  /** Unique within the page: becomes the DOM id `clickable-icon-tracker-info-{id}`. */
  id: string;
  /** What the explanation is about, used for the accessible name "What {label} means". */
  label: string;
  content: ReactNode;
}

/**
 * Keyboard reachable info icon that explains a SECTION of an SaH screen: one per section, placed right after the
 * title (SectionCard `titleAddon`). Figures explain themselves through their underlined labels (TermTooltip)
 * instead. Focus shows the tooltip, blur and Escape hide it.
 *
 * The DOM hooks keep their `tracker-info` names (id, class, data-cy) so the Budget Tracker's tests and styles still
 * match; rename them when a second screen uses this.
 */
const SectionInfo: React.FC<ComponentProps> = ({ id, label, content }) => (
  <ClickableIcon
    id={`tracker-info-${id}`}
    icon={faInfoCircle}
    size="x-small"
    shape="round"
    color="grey"
    toolTip={content}
    tooltipPersistent
    tooltipLimitWidth={300}
    ariaLabel={`What ${label} means`}
    className="tracker-info"
    dataCy="tracker-info"
  />
);

export default SectionInfo;
